import { ClientResponseModel, ClientCommand, EditClientCommand, useEditClientFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { useLocation, useNavigate } from "react-router-dom";

import { ClientForm } from "../../Components/ClientForm/ClientForm";
import { getServerErrorMessage } from "shared/utils/serverError";
import { useTranslation } from "react-i18next";
import { useNotifyModalContext } from "shared/core/state/NotifyModalContext/NotifyModalContext";
import { useState } from "react";
import ErrorAlert from "shared/UI/Alerts/ErrorAlert";

const viewClientsPath = "/clientmanagement";

export const EditClient = () => {
  const { t } = useTranslation();
  const { modalNotify } = useNotifyModalContext();
  const navigateHook = useNavigate();
  const { state } = useLocation();
  let clientData: ClientResponseModel = state;
  const { trigger: editClientRequest } = useEditClientFunctionRequest({});
  const [editClientErrorMessage, setEditClientErrorMessage] = useState<string | null>(null);

  const onSubmit = async (clientDetails: ClientCommand, navFunction?: (response?: ClientResponseModel) => void) => {
    const command: EditClientCommand = {
      ...clientDetails,
      id: clientData.id,
    };
    setEditClientErrorMessage("");
    try {
      const response = await editClientRequest({ body: command });
      modalNotify("success", t("clientForm.successTitle"), t("clientForm.successMessage", { clientName: clientDetails.name, action: "edited" }));
      navFunction ? navFunction(response?.data) : navigateHook(viewClientsPath);
    } catch (error: any) {
      setEditClientErrorMessage(getServerErrorMessage(error, t("clientForm.requestErrorMessage")));
    }
  };

  return (
    <>
      <ClientForm onSubmit={onSubmit} />
      {editClientErrorMessage && <ErrorAlert content={editClientErrorMessage} />}
    </>
  );
};
